import types from 'redux/actions/actionTypes';

export const setPreview = (preview) => ({ type: types.SET_PREVIEW, preview });

export const updatePreview = (data) => ({ type: types.UPDATE_PREVIEW, data });

export const deletePreview = () => ({ type: types.DELETE_PREVIEW });
